import { createContext } from "react";

// The header of GlobalReportsView exposes a DOM node here. A report section renders
// its own controls (refresh, export) into this node with a React portal, so the
// controls sit in the shared header while their state stays in the section.
export const ReportsHeaderSlotContext = createContext<HTMLElement | null>(null);
